import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_ORDER_DIRECTION, DEFAULT_ORDER_FIELD } from './constants';
export var initialAttachmentState = {
  isDownloading: false,
  isFetching: false,
  error: null,
  totalCount: undefined,
  deletableCount: undefined,
  visibleAttachments: []
};
export var attachmentsQuery = function attachmentsQuery() {
  return "\n  query attachmentsQuery($issueKey: String, $startAt: Long, $maxResults: Long, $orderField: AttachmentsOrderField, $orderDirection: OrderDirection) {\n    viewIssue(issueKey: $issueKey) {\n        attachments(startAt: $startAt, maxResults: $maxResults, orderField: $orderField, orderDirection: $orderDirection) {\n            nodes {\n                id\n                filename\n                mimetype\n                mediaApiFileId\n                createdDate\n                filesize\n                parentName\n                parentId\n                author {\n                    accountId\n                }\n                hasRestrictedParent\n            }\n            totalCount\n            deletableCount\n        }\n    }\n  }";
};
var defaultOptions = {
  startAt: 0,
  maxResults: 12,
  orderField: DEFAULT_ORDER_FIELD,
  orderDirection: DEFAULT_ORDER_DIRECTION
};
export var fetchAttachmentsRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(issueKey, options) {
    var mergedOptions, response, _attachmentsResponse$, attachmentsResponse, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mergedOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
          _context.next = 3;
          return fetch('/rest/gira/1/', {
            method: 'POST',
            body: JSON.stringify({
              query: attachmentsQuery(),
              variables: _objectSpread({
                issueKey: issueKey
              }, mergedOptions)
            }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }
          });
        case 3:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 11;
            break;
          }
          _context.next = 7;
          return response.json();
        case 7:
          attachmentsResponse = _context.sent;
          json = attachmentsResponse === null || attachmentsResponse === void 0 || (_attachmentsResponse$ = attachmentsResponse.data) === null || _attachmentsResponse$ === void 0 || (_attachmentsResponse$ = _attachmentsResponse$.viewIssue) === null || _attachmentsResponse$ === void 0 ? void 0 : _attachmentsResponse$.attachments;
          if (!(json && json.nodes && json.totalCount !== undefined)) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", json);
        case 11:
          return _context.abrupt("return", null);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchAttachmentsRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var deleteAttachmentRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(attachmentId) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", Promise.resolve());
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function deleteAttachmentRequest(_x3) {
    return _ref2.apply(this, arguments);
  };
}();